import { render } from "./Table.vue?vue&type=template&id=0c2f61b0&scoped=true"
const script = {}

import "./Table.vue?vue&type=style&index=0&id=0c2f61b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2f61b0"]])

export default __exports__